import { AgxBadge, AgxBadgeType } from '@urbanx/agx-ui-components';
import { CampaignFlowDisplayStatus } from 'Api/Marketing/Types/Marketing';

export const mapPaymentStatus = (
  status?: CampaignFlowDisplayStatus,
  small: boolean = false
) => {
  if (status === undefined || status === null) return <></>;

  switch (status) {
    case CampaignFlowDisplayStatus.Draft:
    case CampaignFlowDisplayStatus.AwaitingFunds:
      return (
        <AgxBadge
          small={small}
          text="Awaiting Funds"
          type={AgxBadgeType.Waiting}
        />
      );
    case CampaignFlowDisplayStatus.PayLaterApplicationSigned:
      return (
        <AgxBadge
          small={small}
          text="Pay Later Application Signed"
          type={AgxBadgeType.Action}
        />
      );
    case CampaignFlowDisplayStatus.Paid:
      return <AgxBadge small={small} text="Paid" type={AgxBadgeType.Success} />;
    case CampaignFlowDisplayStatus.Cancelled:
      return (
        <AgxBadge small={small} text="Cancelled" type={AgxBadgeType.Archived} />
      );
    case CampaignFlowDisplayStatus.PendingSettlement:
      return (
        <AgxBadge
          small={small}
          text="Pending Settlement"
          type={AgxBadgeType.Action}
        />
      );
    case CampaignFlowDisplayStatus.Complete:
      return (
        <AgxBadge small={small} text="Complete" type={AgxBadgeType.Action} />
      );
    case CampaignFlowDisplayStatus.Withdrawn:
      return (
        <AgxBadge small={small} text="Withdrawn" type={AgxBadgeType.Warning} />
      );
    case CampaignFlowDisplayStatus.PayLaterDeclined:
      return (
        <AgxBadge
          small={small}
          text="Pay Later Declined"
          type={AgxBadgeType.Warning}
        />
      );
    default:
      return <></>;
  }
};
